import React, { Component } from 'react';
import axios from 'axios';

const DAY_LABELS = ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pz'];
const DAY_NAMES_FULL = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'];
const MONTH_NAMES = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const RANDEVU_SAAT_KONTROL_API = 'https://randevuapi.uzmdrzelihaaksoy.com/randevu-saat-kontrol';
const RANDEVU_DETAY_API = 'https://randevuapi.uzmdrzelihaaksoy.com/randevu';
const RANDEVU_CREATE_API = 'https://randevuapi.uzmdrzelihaaksoy.com/randevu-olustur';
const RANDEVU_DUZENLE_API = 'https://randevuapi.uzmdrzelihaaksoy.com/randevu-duzenle';

function toISODate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function startOfDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function buildCalendarWeeks(monthDate) {
  const year = monthDate.getFullYear();
  const month = monthDate.getMonth();
  const firstOfMonth = new Date(year, month, 1);
  const startOffset = (firstOfMonth.getDay() + 6) % 7; // Pazartesi = 0
  const gridStart = new Date(year, month, 1 - startOffset);

  const days = [];
  for (let i = 0; i < 42; i++) {
    const date = new Date(gridStart);
    date.setDate(gridStart.getDate() + i);
    days.push({ date, outside: date.getMonth() !== month });
  }

  const weeks = [];
  for (let i = 0; i < days.length; i += 7) {
    weeks.push(days.slice(i, i + 7));
  }
  while (weeks.length > 0 && weeks[weeks.length - 1].every(d => d.outside)) {
    weeks.pop();
  }
  return weeks;
}

class RandevuEkle extends Component {

  constructor(props) {
    super(props);

    const today = startOfDay(new Date());

    this.auth = localStorage.getItem('auth');

    this.state = {
      uuid: null,
      originalDate: '',
      originalTime: '',
      durum: '',
      currentMonth: new Date(today.getFullYear(), today.getMonth(), 1),
      selectedDate: null,
      selectedTime: '',
      patientName: '',
      phone: '',
      email: '',
      details: '',
      formError: '',
      slots: [],
      slotsLoading: false,
      slotsError: '',
      submitting: false,
      detailLoading: false,
      detailError: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.goToPrevMonth = this.goToPrevMonth.bind(this);
    this.goToNextMonth = this.goToNextMonth.bind(this);
  }

  handleBack() {
    this.props.history.goBack();
  }

  componentDidMount() {
    const uuid = this.props.match && this.props.match.params ? this.props.match.params.uuid : null;
    if (!uuid) return;

    this.setState({ uuid, detailLoading: true, detailError: '' });

    const headers = { Authorization: 'Basic ' + this.auth };

    axios.get(`${RANDEVU_DETAY_API}/${uuid}`, { headers })
      .then(response => {
        const randevu = response.data;
        const [y, m, d] = randevu.tarih.split('-').map(Number);
        const selectedDate = new Date(y, m - 1, d);
        const selectedTime = randevu.saat.split('-')[0];

        this.setState({
          currentMonth: new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1),
          selectedDate,
          selectedTime,
          originalDate: randevu.tarih,
          originalTime: selectedTime,
          patientName: randevu.hasta_adi || '',
          details: randevu.aciklama || '',
          durum: randevu.durum || 'planlandi',
          detailLoading: false
        });
        this.fetchAvailability(selectedDate);
      })
      .catch(() => {
        this.setState({ detailLoading: false, detailError: 'Randevu bilgileri alınamadı.' });
      });
  }

  fetchAvailability(date) {
    const iso = toISODate(date);
    this.setState({ slots: [], slotsLoading: true, slotsError: '' });

    const headers = { Authorization: 'Basic ' + this.auth };

    axios.get(`${RANDEVU_SAAT_KONTROL_API}/${iso}`, { headers })
      .then(response => {
        this.setState({ slots: response.data, slotsLoading: false });
      })
      .catch(() => {
        this.setState({ slotsLoading: false, slotsError: 'Uygun saatler alınamadı.' });
      });
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value, formError: '' });
  }

  handleTimeChange(event) {
    this.setState({ selectedTime: event.target.value, formError: '' });
  }

  selectDate(day) {
    if (day.disabled) return;
    this.setState(prev => ({
      selectedDate: day.date,
      selectedTime: prev.selectedDate && toISODate(prev.selectedDate) === toISODate(day.date) ? prev.selectedTime : '',
      currentMonth: day.outside ? new Date(day.date.getFullYear(), day.date.getMonth(), 1) : prev.currentMonth,
      formError: ''
    }));
    this.fetchAvailability(day.date);
  }

  goToPrevMonth() {
    this.setState(prev => ({
      currentMonth: new Date(prev.currentMonth.getFullYear(), prev.currentMonth.getMonth() - 1, 1)
    }));
  }

  goToNextMonth() {
    this.setState(prev => ({
      currentMonth: new Date(prev.currentMonth.getFullYear(), prev.currentMonth.getMonth() + 1, 1)
    }));
  }

  handleCancel() {
    const { uuid } = this.state;
    this.props.history.push(uuid ? `/randevu/${uuid}` : '/randevular');
  }

  handleSubmit(event) {
    event.preventDefault();

    const { patientName, phone, email, selectedDate, selectedTime, details, uuid, durum } = this.state;

    if (!patientName.trim() || !selectedDate || !selectedTime) {
      this.setState({ formError: 'Lütfen zorunlu alanları doldurunuz.' });
      return;
    }

    this.setState({ submitting: true, formError: '' });

    const headers = { Authorization: 'Basic ' + this.auth };
    const tarih = toISODate(selectedDate);

    const request = uuid
      ? axios.put(`${RANDEVU_DUZENLE_API}/${uuid}`, {
          randevu_tarih: tarih,
          randevu_saat: selectedTime,
          randevu_detay: details.trim(),
          durum
        }, { headers })
      : axios.post(RANDEVU_CREATE_API, {
          hasta_adi: patientName.trim(),
          telefon_numarasi: phone.trim(),
          hasta_eposta: email.trim(),
          randevu_detay: details.trim(),
          randevu_uuid: window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`,
          randevu_tarih: tarih,
          randevu_saat: selectedTime
        }, { headers });

    request
      .then(() => {
        this.props.history.push('/gelecek-randevular');
      })
      .catch(error => {
        const message = error.response && error.response.data && error.response.data.message;
        this.setState({ submitting: false, formError: message || 'Randevu kaydedilemedi. Lütfen tekrar deneyiniz.' });
      });
  }

  render() {
    const { currentMonth, selectedDate, selectedTime, patientName, phone, email, details, formError, uuid, originalDate, originalTime, durum, slots, slotsLoading, slotsError, submitting, detailLoading, detailError } = this.state;

    const now = new Date();
    const today = startOfDay(now);
    const isSelectedToday = selectedDate && toISODate(selectedDate) === toISODate(today);
    const weeks = buildCalendarWeeks(currentMonth).map(week =>
      week.map(({ date, outside }) => ({
        date,
        outside,
        today: toISODate(date) === toISODate(today),
        selected: selectedDate && toISODate(date) === toISODate(selectedDate),
        disabled: startOfDay(date) < today || date.getDay() === 0
      }))
    );

    const inputClass = 'flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-sky-500/40 focus:border-sky-500 transition-colors disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-50';
    const labelClass = 'text-sm font-medium text-slate-700';

    return (
      <div className="max-w-lg mx-auto space-y-7">
        <header className="space-y-3">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-slate-900">
            {uuid ? 'Randevu Düzenle' : 'Randevu Oluştur'}
          </h1>
          <button
            type="button" onClick={this.handleBack}
            className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"></path></svg>
            Geri
          </button>
        </header>

        {detailLoading && <p className="text-sm text-slate-500">Yükleniyor...</p>}
        {detailError && <p className="text-sm text-red-500">{detailError}</p>}

        {!detailLoading && !detailError && (
        <form className="space-y-5" onSubmit={this.handleSubmit}>
          <div className="space-y-2">
            <label className={labelClass} htmlFor="patientName">Hasta Adı <span className="text-red-500">*</span></label>
            <input
              id="patientName" name="patientName" placeholder="Ad Soyad"
              value={patientName} onChange={this.handleChange}
              disabled={!!uuid}
              className={inputClass}
            />
          </div>

          <div className="space-y-2">
            <label className={labelClass} htmlFor="phone">Telefon Numarası</label>
            <input
              id="phone" name="phone" type="tel" placeholder="05XXXXXXXXX"
              value={phone} onChange={this.handleChange}
              disabled={!!uuid}
              className={inputClass}
            />
          </div>

          <div className="space-y-2">
            <label className={labelClass} htmlFor="email">E-posta</label>
            <input
              id="email" name="email" type="email" placeholder="ornek@eposta.com"
              value={email} onChange={this.handleChange}
              disabled={!!uuid}
              className={inputClass}
            />
          </div>

          <div className="space-y-2">
            <p className={labelClass}>Randevu Tarihi-Saati <span className="text-red-500">*</span></p>

            <div className="border border-slate-200 rounded-xl bg-white p-3 inline-block">
              <div className="flex flex-col gap-3">
                <div className="flex items-center justify-center gap-2 px-1 py-1">
                  <button
                    type="button" aria-label="Önceki ay" onClick={this.goToPrevMonth}
                    className="inline-flex items-center justify-center rounded-md h-7 w-7 border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors"
                  >
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"></path></svg>
                  </button>
                  <span className="text-sm font-semibold text-slate-800 min-w-[120px] text-center">
                    {MONTH_NAMES[currentMonth.getMonth()]} {currentMonth.getFullYear()}
                  </span>
                  <button
                    type="button" aria-label="Sonraki ay" onClick={this.goToNextMonth}
                    className="inline-flex items-center justify-center rounded-md h-7 w-7 border border-slate-200 bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors"
                  >
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"></path></svg>
                  </button>
                </div>

                <table className="w-full border-collapse">
                  <thead>
                    <tr className="flex">
                      {DAY_LABELS.map((label, i) => (
                        <th key={label} aria-label={DAY_NAMES_FULL[i]} scope="col" className="w-9 text-center text-[0.75rem] font-medium text-slate-400 pb-1">{label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="flex flex-col gap-1">
                    {weeks.map((week, wi) => (
                      <tr key={wi} className="flex">
                        {week.map((day) => {
                          const dayClasses = [
                            'calendar-day w-9 h-9 rounded-md text-sm font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-sky-500'
                          ];
                          if (day.disabled) {
                            dayClasses.push('text-slate-300 opacity-40 cursor-not-allowed');
                          } else {
                            dayClasses.push('cursor-pointer');
                            if (day.outside) dayClasses.push('text-slate-300');
                          }
                          if (day.selected) {
                            dayClasses.push('bg-sky-600 text-white font-semibold');
                          } else if (day.today) {
                            dayClasses.push('bg-slate-100 font-semibold text-slate-900');
                            if (!day.disabled) dayClasses.push('hover:bg-slate-200');
                          } else if (!day.disabled) {
                            dayClasses.push('hover:bg-slate-100');
                          }
                          return (
                            <td key={day.date.toISOString()} className="w-9 h-9 flex items-center justify-center p-0 relative">
                              <button
                                type="button"
                                data-date={toISODate(day.date)}
                                disabled={day.disabled}
                                onClick={() => this.selectDate(day)}
                                className={dayClasses.join(' ')}
                              >
                                {day.date.getDate()}
                              </button>
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="space-y-2">
              <select
                aria-label="Randevu saati"
                disabled={!selectedDate || slotsLoading || !!slotsError}
                value={selectedTime}
                onChange={this.handleTimeChange}
                className={inputClass}
              >
                <option value="" disabled>
                  {!selectedDate ? 'Önce tarih seçiniz' : slotsLoading ? 'Yükleniyor...' : slotsError ? slotsError : 'Saat seçiniz'}
                </option>
                {selectedDate && !slotsLoading && !slotsError && slots.map(slot => {
                  const start = slot.time.split('-')[0];
                  const [h, m] = start.split(':').map(Number);
                  const isPast = isSelectedToday && new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), h, m) <= now;
                  const isOwnSlot = uuid && originalDate === toISODate(selectedDate) && originalTime === start;
                  const available = (slot.status === 'available' || isOwnSlot) && !isPast;
                  return (
                    <option key={slot.time} value={start} disabled={!available}>
                      {slot.time}{available ? '' : isPast ? ' (Geçti)' : ' (Dolu)'}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>

          {uuid && (
            <div className="space-y-2">
              <label className={labelClass} htmlFor="durum">Durum</label>
              <select
                id="durum" name="durum" value={durum} onChange={this.handleChange}
                className={inputClass}
              >
                <option value="planlandi">Planlandı</option>
                <option value="iptal">İptal Edildi</option>
                <option value="tamamlandi">Tamamlandı</option>
              </select>
            </div>
          )}

          <div className="space-y-2">
            <label className={labelClass} htmlFor="details">Detay</label>
            <textarea
              id="details" name="details" rows="3" placeholder="Şikayet, not veya diğer bilgiler..."
              value={details} onChange={this.handleChange}
              className={`${inputClass} h-auto min-h-[80px] resize-none`}
            />
          </div>

          {formError && <p className="text-sm text-red-500">{formError}</p>}

          <div className="flex gap-3 pt-2">
            <button
              type="button" onClick={this.handleCancel}
              className="flex-1 h-10 px-4 rounded-md border border-slate-200 bg-white text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
            >
              {uuid ? 'Geri' : 'İptal'}
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="flex-1 h-10 px-4 rounded-md bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {submitting ? 'Gönderiliyor...' : uuid ? 'Güncelle' : 'Gönder'}
            </button>
          </div>
        </form>
        )}
      </div>
    );
  }
}

export default RandevuEkle
